import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbCheckoutReviewPricesAdapter } from './mb-checkout-review-prices.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutReviewPricesConnector {
  constructor (protected adapter: MbCheckoutReviewPricesAdapter) {}

  get (cartID: string): Observable<any> {
    return this.adapter.load(cartID)
  }
}
